import React from 'react';
import { TableBody, TableCell, TableHeader, TableRow, TableHeaderCell, Table } from './styled';
/**
 * A simple table component which provides flexible, pre-styled table elements.
 */
export const SimpleTable = ({ striped = true, className, children }) => (React.createElement(Table, { striped: striped, className: className }, children));
SimpleTable.Header = TableHeader;
SimpleTable.Body = TableBody;
SimpleTable.Row = TableRow;
SimpleTable.HeaderCell = TableHeaderCell;
SimpleTable.Cell = TableCell;
//# sourceMappingURL=SimpleTable.js.map